import { listedOnTools } from './outreach-alfred';

/**
 * The home's "Connected" and "Recommended" connector groups (Home 2's section, the Overview's rail). A row the
 * Tools tab leaves out (`listedOnTools`: a server-hidden row, or Alfred while it is on Outreach) is in neither:
 * each card opens the Tools tab at that connector, and the Tools tab has no card for it.
 * Import-light so it is unit-testable in the node-env suite. Mirrors iOS/Android `HomeFeed.connectorGroups`.
 */
export function homeConnectorGroups<T extends { toolkit: string; connected: boolean; hiddenFromConnectorsList?: boolean }>(
  connectors: readonly T[],
  alfredOnOutreach: boolean,
): { connected: T[]; recommended: T[] } {
  const listed = connectors.filter((c) => listedOnTools(c, alfredOnOutreach));
  return { connected: listed.filter((c) => c.connected), recommended: listed.filter((c) => !c.connected) };
}
